export const welcome_tour_en = {
  skip_tour: "Skip tour",
  tour_company_search_title: "You're in Company Search",
  tour_define_search_title: "Define your search",
  tour_review_results_title: "Review matching results",
  tour_save_results_title: "Save results & start outreach",
  tour_save_results_desc:
    "On each row, use these buttons to act on a single company.",
  tour_bulk_save_title: "Bulk save with checkboxes",
  tour_bulk_save_desc:
    "Select multiple companies using the checkboxes, then save or sequence them all at once from the action bar above.",
  back: "Back",
  welcome_dialog_title: "Welcome to {nickname}!👋",
  welcome_dialog_subtitle: "Let’s find exactly what you’re looking for",
  welcome_dialog_content:
    "Pubrio Search includes two dedicated experiences, <strong>People Search</strong> for discovering decision-makers and <strong>Company Search</strong> for exploring businesses. You can start with either one and switch anytime.",
  tour_company_search_desc:
    "This page is designed to help you discover and analyze companies—not individual contacts.",
  tour_people_search_title: "People Search",
  tour_people_search_desc:
    "This page is dedicated to finding individual professionals based on their role, experience, and company.",
  tour_define_search_desc:
    "Add filters like job title, company name, industry, location, company size, or keywords to narrow down your results.",
  tour_review_results_desc:
    "Browse through verified profiles that match your criteria. Each result includes key details to help you decide quickly.",
  finish_tour: "Finish tour",

  // onboarding
  nav_onboarding_popover_title: "Finish your setup",
  nav_onboarding_popover_title_start: "Set up your workspace",
  nav_onboarding_popover_title_done: "You're ready to prospect",
  nav_onboarding_popover_progress: "Progress: {progress}%",
  onboarding_widget_steps_done: "{completed} of {total} steps done",
  onboarding_widget_next_up: "Next up",
  onboarding_widget_view_all: "View all steps",
  nav_onboarding_popover_button: "Continue setup",
  nav_onboarding_popover_button_done: "View summary",
  onboarding_popover_done_sub: "All steps complete · {total} credits earned",
  onboarding_complete_eyebrow: "Setup complete",
  onboarding_complete_headline: "You're ready to prospect",
  onboarding_complete_subtitle:
    "Every step is done and your {total} bonus credits are in your balance. Put them to work on your first search.",
  onboarding_complete_stat_steps: "{count} steps complete",
  onboarding_complete_stat_credits: "{total} credits earned",
  onboarding_complete_cta: "Start prospecting",
  onboarding_complete_secondary: "Review your setup",
  onboarding_list_error: "We couldn't load your setup steps.",
  onboarding_list_retry: "Retry",
  onboarding_hub: "Onboarding Hub",
  connected: "Connected",
  onboarding_page_title_progress: "You're making real progress 🎯",
  onboarding_credits_earned: "{earned}/{total} credits earned",
  onboarding_bar_tip:
    "Need help getting started? Visit the Pubrio Academy for tutorials, webinars, and guides.",
  onboarding_bar_button: "Go to Academy",
  onboarding_complete_count: "{completed}/{total} completed",

  earned_credits:
    "Earned <span class='plan-money-blue'></span> {credits} credits",
  credits_earned:
    "<span class='plan-money-gray'></span> {credits} credits earned",

  time_cost: "About 0 minutes | About 1 minute | About {count} minutes",
};

// ── Traditional Chinese (Hong Kong) ──────────────────────────────────────────
export const welcome_tour_zhHk = {
  // onboarding
  nav_onboarding_popover_title: "完成您的設定",
  nav_onboarding_popover_title_start: "設定您的工作區",
  nav_onboarding_popover_title_done: "您已準備好開發客戶",
  nav_onboarding_popover_progress: "進度：{progress}%",
  onboarding_widget_steps_done: "{total} 個步驟中已完成 {completed} 個",
  onboarding_widget_next_up: "接下來",
  onboarding_widget_view_all: "查看所有步驟",
  nav_onboarding_popover_button: "繼續設定",
  nav_onboarding_popover_button_done: "查看摘要",
  onboarding_popover_done_sub: "所有步驟已完成 · 已獲得 {total} 積分",
  onboarding_complete_eyebrow: "設定完成",
  onboarding_complete_headline: "您已準備好開發客戶",
  onboarding_complete_subtitle:
    "所有步驟已完成，{total} 積分已存入您的帳戶。立即運用於您的第一次搜尋。",
  onboarding_complete_stat_steps: "已完成 {count} 個步驟",
  onboarding_complete_stat_credits: "已獲得 {total} 積分",
  onboarding_complete_cta: "開始開發客戶",
  onboarding_complete_secondary: "查看設定",
  onboarding_list_error: "無法載入您的設定步驟。",
  onboarding_list_retry: "重試",
  onboarding_hub: "新手引導中心",
  onboarding_credits_earned: "{earned}/{total} 積分已獲得",
  onboarding_bar_tip:
    "需要協助入門？前往 Pubrio 學院，獲取教學、網絡研討會及指南。",
  onboarding_bar_button: "前往學院",
  onboarding_complete_count: "{completed}/{total} 已完成",

  earned_credits: "可獲得 <span class='plan-money-blue'></span> {credits} 積分",
  credits_earned: "<span class='plan-money-gray'></span> {credits} 積分已獲得",

  time_cost: "約 0 分鐘 | 約 1 分鐘 | 約 {count} 分鐘",
  skip_tour: "跳過導覽",
  tour_company_search_title: "您正在使用公司搜尋",
  tour_define_search_title: "定義搜尋條件",
  tour_review_results_title: "查看符合結果",
  tour_save_results_title: "儲存結果並開始外展",
  tour_save_results_desc: "在每一行中，使用這些按鈕對單一公司執行操作。",
  tour_bulk_save_title: "使用核取方塊批量儲存",
  tour_bulk_save_desc:
    "使用核取方塊選取多家公司，然後從上方的操作列一次儲存或加入序列。",
  back: "返回",
  welcome_dialog_title: "歡迎，{nickname}！👋",
  welcome_dialog_subtitle: "讓我們精準找到您所需的目標",
  welcome_dialog_content:
    "Pubrio Search 提供兩種專屬體驗，<strong>人員搜尋</strong>用於發掘決策者，<strong>公司搜尋</strong>用於探索目標企業。您可從任一功能開始，隨時切換。",
  tour_company_search_desc:
    "此頁面專為協助您發掘及分析 B2B 企業而設計，而非個別聯絡人。",
  tour_people_search_title: "人員搜尋",
  tour_people_search_desc:
    "此頁面專用於根據職位、工作經歷及所屬公司，尋找個別專業人士與決策者。",
  tour_define_search_desc:
    "新增職位名稱、公司名稱、行業、地點、公司規模或關鍵字等篩選條件，精準縮小搜尋範圍。",
  tour_review_results_desc:
    "瀏覽符合您條件的已驗證資料。每筆結果均包含關鍵資訊，協助您快速作出決策。",
  finish_tour: "完成導覽",
};

// ── Simplified Chinese ────────────────────────────────────────────────────────
export const welcome_tour_zhCn = {
  // onboarding
  nav_onboarding_popover_title: "完成您的设置",
  nav_onboarding_popover_title_start: "设置您的工作区",
  nav_onboarding_popover_title_done: "您已准备好开发客户",
  nav_onboarding_popover_progress: "进度：{progress}%",
  onboarding_widget_steps_done: "{total} 个步骤中已完成 {completed} 个",
  onboarding_widget_next_up: "接下来",
  onboarding_widget_view_all: "查看所有步骤",
  nav_onboarding_popover_button: "继续设置",
  nav_onboarding_popover_button_done: "查看摘要",
  onboarding_popover_done_sub: "所有步骤已完成 · 已获得 {total} 积分",
  onboarding_complete_eyebrow: "设置完成",
  onboarding_complete_headline: "您已准备好开发客户",
  onboarding_complete_subtitle:
    "所有步骤已完成，{total} 积分已存入您的账户。立即用于您的第一次搜索。",
  onboarding_complete_stat_steps: "已完成 {count} 个步骤",
  onboarding_complete_stat_credits: "已获得 {total} 积分",
  onboarding_complete_cta: "开始开发客户",
  onboarding_complete_secondary: "查看设置",
  onboarding_list_error: "无法加载您的设置步骤。",
  onboarding_list_retry: "重试",
  onboarding_hub: "新手引导中心",
  onboarding_credits_earned: "{earned}/{total} 积分已获得",
  onboarding_bar_tip:
    "需要帮助入门？访问 Pubrio 学院，获取教程、网络研讨会和指南。",
  onboarding_bar_button: "前往学院",
  onboarding_complete_count: "{completed}/{total} 已完成",

  earned_credits: "可获得 <span class='plan-money-blue'></span> {credits} 积分",
  credits_earned: "<span class='plan-money-gray'></span> {credits} 积分已获得",

  time_cost: "约 0 分钟 | 约 1 分钟 | 约 {count} 分钟",
  skip_tour: "跳过导览",
  tour_company_search_title: "您正在使用公司搜索",
  tour_define_search_title: "定义搜索条件",
  tour_review_results_title: "查看匹配结果",
  tour_save_results_title: "保存结果并开始外展",
  tour_save_results_desc: "在每一行中，使用这些按钮对单个公司执行操作。",
  tour_bulk_save_title: "使用复选框批量保存",
  tour_bulk_save_desc:
    "使用复选框选择多家公司，然后从上方操作栏一次性保存或加入序列。",
  back: "返回",
  welcome_dialog_title: "欢迎，{nickname}！👋",
  welcome_dialog_subtitle: "让我们精准找到您所需的目标",
  welcome_dialog_content:
    "Pubrio Search 提供两种专属体验，<strong>人员搜索</strong>用于发掘决策者，<strong>公司搜索</strong>用于探索目标企业。您可从任一功能开始，随时切换。",
  tour_company_search_desc:
    "此页面专为协助您发掘和分析 B2B 企业而设计，而非个别联系人。",
  tour_people_search_title: "人员搜索",
  tour_people_search_desc:
    "此页面专用于根据职位、工作经历及所属公司，寻找个别专业人士与决策者。",
  tour_define_search_desc:
    "添加职位名称、公司名称、行业、地点、公司规模或关键字等筛选条件，精准缩小搜索范围。",
  tour_review_results_desc:
    "浏览符合您条件的已验证资料。每条结果均包含关键信息，帮助您快速作出决策。",
  finish_tour: "完成导览",
};

// ── Hindi ─────────────────────────────────────────────────────────────────────
export const welcome_tour_hi = {
  // onboarding
  nav_onboarding_popover_title: "अपना सेटअप पूरा करें",
  nav_onboarding_popover_title_start: "अपना वर्कस्पेस सेट करें",
  nav_onboarding_popover_title_done: "आप प्रॉस्पेक्टिंग के लिए तैयार हैं",
  nav_onboarding_popover_progress: "प्रगति: {progress}%",
  onboarding_widget_steps_done: "{total} में से {completed} चरण पूर्ण",
  onboarding_widget_next_up: "आगे",
  onboarding_widget_view_all: "सभी चरण देखें",
  nav_onboarding_popover_button: "सेटअप जारी रखें",
  nav_onboarding_popover_button_done: "सारांश देखें",
  onboarding_popover_done_sub: "सभी चरण पूर्ण · {total} क्रेडिट अर्जित",
  onboarding_complete_eyebrow: "सेटअप पूर्ण",
  onboarding_complete_headline: "आप प्रॉस्पेक्टिंग के लिए तैयार हैं",
  onboarding_complete_subtitle:
    "हर चरण पूरा हो गया और आपके {total} बोनस क्रेडिट आपके बैलेंस में हैं। उन्हें अपनी पहली खोज में लगाएं।",
  onboarding_complete_stat_steps: "{count} चरण पूर्ण",
  onboarding_complete_stat_credits: "{total} क्रेडिट अर्जित",
  onboarding_complete_cta: "प्रॉस्पेक्टिंग शुरू करें",
  onboarding_complete_secondary: "अपना सेटअप देखें",
  onboarding_list_error: "हम आपके सेटअप चरण लोड नहीं कर सके।",
  onboarding_list_retry: "पुनः प्रयास करें",
  onboarding_hub: "ऑनबोर्डिंग हब",
  onboarding_credits_earned: "{earned}/{total} क्रेडिट अर्जित",
  onboarding_bar_tip:
    "शुरुआत में मदद चाहिए? ट्यूटोरियल, वेबिनार और गाइड के लिए Pubrio Academy देखें।",
  onboarding_bar_button: "अकादमी पर जाएं",
  onboarding_complete_count: "{completed}/{total} पूर्ण",

  earned_credits:
    "<span class='plan-money-blue'></span> {credits} क्रेडिट कमाएं",
  credits_earned:
    "<span class='plan-money-gray'></span> {credits} क्रेडिट अर्जित",

  time_cost: "लगभग 0 मिनट | लगभग 1 मिनट | लगभग {count} मिनट",
  skip_tour: "टूर छोड़ें",
  tour_company_search_title: "आप कंपनी सर्च में हैं",
  tour_define_search_title: "अपनी सर्च परिभाषित करें",
  tour_review_results_title: "मिलते-जुलते परिणाम देखें",
  tour_save_results_title: "परिणाम सहेजें और आउटरीच शुरू करें",
  tour_save_results_desc:
    "प्रत्येक पंक्ति में, एक कंपनी पर कार्य करने के लिए इन बटनों का उपयोग करें।",
  tour_bulk_save_title: "चेकबॉक्स से बल्क सेव करें",
  tour_bulk_save_desc:
    "चेकबॉक्स का उपयोग करके कई कंपनियों को चुनें, फिर ऊपर के एक्शन बार से सभी को एक बार में सहेजें या सीक्वेंस करें।",
  back: "वापस",
  welcome_dialog_title: "स्वागत है, {nickname}! 👋",
  welcome_dialog_subtitle: "आइए वह खोजें जो आप ढूंढ रहे हैं",
  welcome_dialog_content:
    "Pubrio Search में दो समर्पित अनुभव शामिल हैं — <strong>People Search</strong> निर्णय-निर्माताओं को खोजने के लिए, और <strong>Company Search</strong> B2B कंपनियों का पता लगाने के लिए। आप किसी भी एक से शुरू कर सकते हैं और कभी भी स्विच कर सकते हैं।",
  tour_company_search_desc:
    "यह पेज SaaS और टेक उद्योग में कंपनियों की खोज और विश्लेषण करने के लिए बनाया गया है — व्यक्तिगत संपर्कों के लिए नहीं।",
  tour_people_search_title: "People Search",
  tour_people_search_desc:
    "यह पेज भूमिका, अनुभव और कंपनी के आधार पर व्यक्तिगत पेशेवरों और निर्णय-निर्माताओं को खोजने के लिए समर्पित है।",
  tour_define_search_desc:
    "परिणामों को सटीक बनाने के लिए जॉब टाइटल, कंपनी नाम, उद्योग, स्थान, कंपनी साइज़ या कीवर्ड जैसे फ़िल्टर जोड़ें।",
  tour_review_results_desc:
    "अपने मानदंडों से मेल खाने वाले सत्यापित प्रोफ़ाइल ब्राउज़ करें। प्रत्येक परिणाम में मुख्य विवरण शामिल हैं जो त्वरित निर्णय लेने में मदद करते हैं।",
  finish_tour: "टूर समाप्त करें",
};

// ── Japanese ──────────────────────────────────────────────────────────────────
export const welcome_tour_ja = {
  // onboarding
  nav_onboarding_popover_title: "セットアップを完了する",
  nav_onboarding_popover_title_start: "ワークスペースを設定",
  nav_onboarding_popover_title_done: "プロスペクティングの準備が整いました",
  nav_onboarding_popover_progress: "進捗: {progress}%",
  onboarding_widget_steps_done: "{total} ステップ中 {completed} 完了",
  onboarding_widget_next_up: "次のステップ",
  onboarding_widget_view_all: "すべてのステップを見る",
  nav_onboarding_popover_button: "セットアップを続ける",
  nav_onboarding_popover_button_done: "概要を見る",
  onboarding_popover_done_sub: "すべてのステップ完了 · {total} クレジット獲得",
  onboarding_complete_eyebrow: "セットアップ完了",
  onboarding_complete_headline: "プロスペクティングの準備が整いました",
  onboarding_complete_subtitle:
    "すべてのステップが完了し、{total} クレジットが残高に追加されました。最初の検索に活用しましょう。",
  onboarding_complete_stat_steps: "{count} ステップ完了",
  onboarding_complete_stat_credits: "{total} クレジット獲得",
  onboarding_complete_cta: "プロスペクティングを開始",
  onboarding_complete_secondary: "設定を確認",
  onboarding_list_error: "セットアップ手順を読み込めませんでした。",
  onboarding_list_retry: "再試行",
  onboarding_hub: "オンボーディングハブ",
  onboarding_credits_earned: "{earned}/{total} クレジット獲得",
  onboarding_bar_tip:
    "始め方にお困りですか？Pubrioアカデミーでチュートリアル、ウェビナー、ガイドをご覧ください。",
  onboarding_bar_button: "アカデミーへ",
  onboarding_complete_count: "{completed}/{total} 完了",

  earned_credits:
    "<span class='plan-money-blue'></span> {credits} クレジット獲得可能",
  credits_earned:
    "<span class='plan-money-gray'></span> {credits} クレジット獲得",

  time_cost: "約0分 | 約1分 | 約{count}分",
  skip_tour: "ツアーをスキップ",
  tour_company_search_title: "企業検索を使用中",
  tour_define_search_title: "検索条件を設定する",
  tour_review_results_title: "検索結果を確認する",
  tour_save_results_title: "結果を保存してアウトリーチを開始する",
  tour_save_results_desc: "各行のボタンを使って、1社ずつ操作を行います。",
  tour_bulk_save_title: "チェックボックスで一括保存",
  tour_bulk_save_desc:
    "チェックボックスで複数の企業を選択し、上部のアクションバーからまとめて保存またはシーケンスに追加できます。",
  back: "戻る",
  welcome_dialog_title: "{nickname}さん、ようこそ！👋",
  welcome_dialog_subtitle: "お探しのターゲットを正確に見つけましょう",
  welcome_dialog_content:
    "Pubrio Search には 2 つの専用機能があります。<strong>People Search</strong> は意思決定者の発掘に、<strong>Company Search</strong> は B2B 企業の調査に特化しています。どちらからでも始めることができ、いつでも切り替え可能です。",
  tour_company_search_desc:
    "このページは、SaaS・テック業界の企業を発掘・分析するために設計されています。個人の連絡先検索には対応していません。",
  tour_people_search_title: "People Search",
  tour_people_search_desc:
    "このページは、役職・経験・所属企業に基づいて個人のプロフェッショナルや意思決定者を検索するための専用ページです。",
  tour_define_search_desc:
    "役職名、企業名、業界、所在地、企業規模、キーワードなどのフィルターを追加して、検索結果を絞り込みましょう。",
  tour_review_results_desc:
    "条件に合致した検証済みプロフィールを閲覧できます。各結果には重要な詳細情報が含まれており、迅速な意思決定をサポートします。",
  finish_tour: "ツアーを終了",
};

// ── Korean ────────────────────────────────────────────────────────────────────
export const welcome_tour_ko = {
  // onboarding
  nav_onboarding_popover_title: "설정 완료하기",
  nav_onboarding_popover_title_start: "워크스페이스 설정",
  nav_onboarding_popover_title_done: "프로스펙팅을 시작할 준비가 되었습니다",
  nav_onboarding_popover_progress: "진행률: {progress}%",
  onboarding_widget_steps_done: "{total}단계 중 {completed}단계 완료",
  onboarding_widget_next_up: "다음 단계",
  onboarding_widget_view_all: "모든 단계 보기",
  nav_onboarding_popover_button: "설정 계속하기",
  nav_onboarding_popover_button_done: "요약 보기",
  onboarding_popover_done_sub: "모든 단계 완료 · {total} 크레딧 획득",
  onboarding_complete_eyebrow: "설정 완료",
  onboarding_complete_headline: "프로스펙팅을 시작할 준비가 되었습니다",
  onboarding_complete_subtitle:
    "모든 단계가 완료되었고 {total} 크레딧이 잔액에 추가되었습니다. 첫 검색에 활용해 보세요.",
  onboarding_complete_stat_steps: "{count}단계 완료",
  onboarding_complete_stat_credits: "{total} 크레딧 획득",
  onboarding_complete_cta: "프로스펙팅 시작",
  onboarding_complete_secondary: "설정 검토",
  onboarding_list_error: "설정 단계를 불러오지 못했습니다.",
  onboarding_list_retry: "다시 시도",
  onboarding_hub: "온보딩 허브",
  onboarding_credits_earned: "{earned}/{total} 크레딧 획득",
  onboarding_bar_tip:
    "시작이 필요하신가요? Pubrio 아카데미에서 튜토리얼, 웨비나, 가이드를 확인하세요.",
  onboarding_bar_button: "아카데미로 이동",
  onboarding_complete_count: "{completed}/{total} 완료됨",

  earned_credits: "<span class='plan-money-blue'></span> {credits} 크레딧 획득 가능",
  credits_earned: "<span class='plan-money-gray'></span> {credits} 크레딧 획득",

  time_cost: "약 0분 | 약 1분 | 약 {count}분",

  skip_tour: "투어 건너뛰기",
  tour_company_search_title: "기업 검색 화면입니다",
  tour_define_search_title: "검색 조건 설정하기",
  tour_review_results_title: "검색 결과 확인하기",
  tour_save_results_title: "결과 저장 및 아웃리치 시작",
  tour_save_results_desc:
    "각 행에서 이 버튼을 사용해 개별 기업에 대한 작업을 수행하세요.",
  tour_bulk_save_title: "체크박스로 일괄 저장",
  tour_bulk_save_desc:
    "체크박스를 사용해 여러 기업을 선택한 후, 상단 액션 바에서 한 번에 저장하거나 시퀀스에 추가하세요.",
  back: "이전",
  welcome_dialog_title: "{nickname}님, 환영합니다! 👋",
  welcome_dialog_subtitle: "찾고 계신 정확한 대상을 함께 발견해봅시다",
  welcome_dialog_content:
    "Pubrio Search는 두 가지 전용 기능을 제공합니다. <strong>People Search</strong>는 의사결정자를 발굴하고, <strong>Company Search</strong>는 B2B 기업을 탐색합니다. 원하는 기능부터 시작하고 언제든지 전환할 수 있습니다.",
  tour_company_search_desc:
    "이 페이지는 SaaS 및 테크 산업의 기업을 발굴하고 분석하는 데 특화되어 있으며, 개인 연락처 검색용이 아닙니다.",
  tour_people_search_title: "People Search",
  tour_people_search_desc:
    "이 페이지는 직책, 경력, 소속 기업을 기반으로 개별 전문가 및 의사결정자를 찾기 위한 전용 페이지입니다.",
  tour_define_search_desc:
    "직책, 회사명, 산업, 위치, 기업 규모, 키워드 등의 필터를 추가하여 검색 결과를 정밀하게 좁혀보세요.",
  tour_review_results_desc:
    "조건에 맞는 인증된 프로필을 검색하세요. 각 결과에는 빠른 의사결정을 돕는 핵심 정보가 포함되어 있습니다.",
  finish_tour: "투어 완료",
};
